import React from "react";
import {Affix, Row, Col, Form, Menu, Avatar, Drawer, Input, Space, Button} from 'antd';
import {NavLink} from "react-router-dom";
import "./navbar.css"
import "./index.css"
import {connect} from "react-redux";
import {signOut, signInWithPhoneNumber, verifyCode} from "../../Store/Actions/auth";
import firebase from "../../Config/fbConfig";
const { SubMenu } = Menu;
const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

class Navbar extends React.Component {

    state = {
        currentStep: 0,
        visible: false,
        loading: false,
        confirmationResult: null
    };

    componentDidMount() {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container",
            {
            size:"invisible",
            "callback": function(response) {
                signInWithPhoneNumber();
            }
        });
    }

    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    onFinish = values => {
        this.setState({ loading: true });
        if(this.state.currentStep === 0){
            const appVerifier = window.recaptchaVerifier;
            const phoneNumber = `+7${values.phone}`;
            signInWithPhoneNumber({ phoneNumber, appVerifier }, (res) => {
                this.setState({
                    confirmationResult: res,
                    currentStep: res ? 1 : 0,
                    loading: false,
                })
            });
        } else {
            const { confirmationResult } = this.state;
            const { code } = values;
            if (confirmationResult) {
                verifyCode({ confirmationResult, code}, (res) => {
                    this.onClose();
                    this.setState({
                        currentStep: 0,
                        loading: false,
                    });
                })
            }
        }
    };

    render() {
        const { auth, current } = this.props;
        const { visible, currentStep, loading } = this.state;

        return (
            <div>
                <div className="uk-navbar-container uk-light tm-toolbar-container">
                    <div className="uk-container" uk-navbar="true">
                        <div className="uk-navbar-right">
                            <nav>
                                <ul className="uk-navbar-nav uk-text-emphasis">
                                    <li>
                                        <a className="uk-text-emphasis">
                                            Поделиться
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.facebook.com/sharer/sharer.php?u=#https://taraz-alumni.firebaseapp.com"
                                           target="_blank">
                                            <i className="fab fa-facebook-f uk-text-emphasis"/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://telegram.me/share/url?url=https://taraz-alumni.firebaseapp.com"
                                           target="_blank">
                                            <i className="fab fa-telegram-plane uk-text-emphasis"/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="whatsapp://send?text=https://taraz-alumni.firebaseapp.com" target="_blank">
                                            <i className="fab fa-whatsapp uk-text-emphasis"/>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <Affix offsetTop={0}>
                    <div className="navbar-menu">
                        <div className="uk-container">
                            <Row>
                                <Col flex="auto">
                                    <Menu selectedKeys={[current]} mode="horizontal">
                                        <Menu.Item key="home">
                                            <NavLink className="uk-text-bold" to={"/"}>
                                                <img className="uk-margin-small-right" width={100} src={require("./logo.png")} />
                                            </NavLink>
                                        </Menu.Item>
                                        <SubMenu title="Про нас">
                                            <Menu.Item key="about">
                                                <NavLink to={"/about"}>
                                                    Наша  история
                                                </NavLink>
                                            </Menu.Item>
                                            <Menu.Item key="terms">
                                                <NavLink to={"/terms"}>
                                                    Условия и положения
                                                </NavLink>
                                            </Menu.Item>
                                        </SubMenu>
                                        <Menu.Item key="jobs">
                                            <NavLink to={"/jobs"}>
                                                Работа
                                            </NavLink>
                                        </Menu.Item>
                                    </Menu>
                                </Col>
                                <Col span={4}>
                                    <Menu selectedKeys={[current]} mode="horizontal">
                                        { auth.uid ?
                                            <SubMenu title={
                                                <span>
                                                <Avatar className="uk-margin-small-right" src={auth.photoURL} />{ auth.displayName }
                                            </span>
                                            }>
                                                <Menu.Item key="admin">
                                                    <NavLink to={"/admin"}>
                                                        Admin page
                                                    </NavLink>
                                                </Menu.Item>
                                                <Menu.Item onClick={() => signOut()}>
                                                    Log out
                                                </Menu.Item>
                                            </SubMenu>

                                            :
                                            <Menu.Item onClick={this.showDrawer}>
                                                Войти
                                            </Menu.Item>
                                        }

                                    </Menu>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Affix>
                <div id="recaptcha-container" />

                <Drawer
                    width={440}
                    title="Login"
                    placement="right"
                    onClose={this.onClose}
                    visible={visible}
                >
                    <h1 className="uk-text-center uk-h2 uk-text-bold uk-margin">
                        <img className="uk-margin-small-right" width={30} src="https://cdn.fs.brandfolder.com/ywc2mR5aQtWlEWkIu3T3" /> Fresh Organic Food
                    </h1>
                    <div className="uk-text-center uk-margin uk-margin-large-bottom">
                        <Space>
                            <a className="uk-text-left" href={"https://apps.apple.com/kz/app/nulife/id1498300799"}>
                                <img width={120} src={require("../Layout/appstore.png")} />
                            </a>
                            <a href={"https://play.google.com/store/apps/details?id=com.naltynbekkz.nulife"}>
                                <img width={120} src={require("../Layout/playstore.png")} />
                            </a>
                        </Space>
                    </div>


                    <Form {...layout} onFinish={this.onFinish}>
                        <Form.Item
                            label={
                                <h3 className="uk-h4 uk-margin-remove">
                                    Phone number
                                </h3>
                            }
                            name="phone"
                            rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                            <Input disabled={currentStep !== 0} placeholder="Phone number" size="large" prefix="+7" />
                        </Form.Item>
                        { currentStep > 0 ?
                            <Form.Item
                                label={
                                    <h3 className="uk-h4 uk-margin-remove">
                                        One time code
                                    </h3>
                                }
                                name="code"
                                rules={[{ required: true, message: 'Please input your username!' }]}
                            >
                                <Input disabled={currentStep !== 1} placeholder="Code" size="large" />
                            </Form.Item>
                        : null }
                        <Form.Item>
                            <Button disabled={loading} loading={loading} type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Drawer>

            </div>
        );
    }

};



const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
    }
}

export default connect(mapStateToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/Components/Layout/Navbar.js